import { CSSProperties } from "react";

export const LoadingContainer: CSSProperties = {
  width: "100%",
  minHeight: "100%",
  position: "relative",
  height: "100vh",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  zIndex: 4,
};
